import a from "../icon-button/pendo-icon-button.vue.js";
const u = {
  name: "GroupCell",
  inject: ["$table"],
  props: {
    row: Object,
    rowIndex: Number
  },
  computed: {
    expanded() {
      const t = this.row[this.$table.rowKey];
      return this.$table.groupExpandedKeys.has(t);
    },
    expandButtonStyle() {
      return this.$table.hasFixedColumns ? {
        height: `${this.row.height}px`,
        position: "sticky",
        left: 0
      } : { height: `${this.row.height}px` };
    },
    cellChildStyle() {
      if (this.$table.hasFixedColumns)
        return {
          position: "sticky",
          left: this.$table.groupConfig.expandable ? "48px" : "16px"
          // 48px is the width of the expand icon, 16px is the padding-left of the cell
        };
    }
  },
  methods: {
    toggleRowExpand() {
      this.$table.toggleRowGroupExpand(this.row);
    }
  },
  render(t) {
    const { row: o, rowIndex: s, $table: e, expanded: l, toggleRowExpand: n, expandButtonStyle: p, cellChildStyle: r } = this;
    let i = o[e.rowKey];
    e.$slots.groupRow && (i = e.$slots.groupRow({
      row: o,
      rowIndex: s,
      toggleRowExpand: n
    }));
    function d() {
      return e.groupConfig.expandable ? t(
        "div",
        {
          class: [
            "pendo-table__group-expand",
            {
              "is-expanded": l
            }
          ],
          style: { ...p }
        },
        [
          t(a, {
            props: {
              icon: "chevron-up",
              tooltip: l ? "Collapse" : "Expand"
            },
            attrs: {
              size: "mini"
            },
            on: {
              click: n
            }
          })
        ]
      ) : null;
    }
    return t(
      "td",
      {
        class: "pendo-table__column pendo-table__column--group",
        attrs: {
          colspan: e.tableColumns.length
        },
        style: { height: `${o.height}px` }
      },
      [
        t(
          "div",
          {
            class: "pendo-table__cell"
          },
          [d(), t("div", { style: { ...r } }, i)]
        )
      ]
    );
  }
};
export {
  u as default
};
//# sourceMappingURL=group-cell.js.map
